const config = {
  //BASE_PATH: "https://legalhelp.appbites.dev/api/",
  BASE_PATH: "https://lgc.appbit.es/api/",
};

export default config;
